var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronUpDown = function SvgChevronUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.295 12.71a1 1 0 0 1 .702-1.718 1 1 0 0 1 .703.288L8 13.905l2.3-2.635a1 1 0 0 1 1.628.327 1 1 0 0 1-.223 1.103l-2.45 2.64-.195.21a1.5 1.5 0 0 1-2.12 0l-2.645-2.84Zm7.41-9.42A1.001 1.001 0 1 1 10.3 4.72L8 2.095 5.7 4.73a1 1 0 0 1-1.628-.327A1 1 0 0 1 4.295 3.3L6.745.66 6.94.45a1.5 1.5 0 0 1 2.12 0l2.645 2.84Z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronUpDown;